import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "ico-unknown-file",
  "use": "ico-unknown-file-usage",
  "viewBox": "-64 0 512 512",
  "content": "<symbol viewBox=\"-64 0 512 512\" xmlns=\"http://www.w3.org/2000/svg\" id=\"ico-unknown-file\"><path d=\"M369.9 97.9L286 14C277 5 264.8-.1 252.1-.1H48C21.5 0 0 21.5 0 48v416c0 26.5 21.5 48 48 48h288c26.5 0 48-21.5 48-48V131.9c0-12.7-5.1-25-14.1-34zM332.1 128H256V51.9l76.1 76.1zM48 464V48h160v104c0 13.3 10.7 24 24 24h104v288H48z\" fill=\"#acacac\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol